import { Product } from '../../interfaces/subscriptions';
import * as styles from './KeepSubscriptions.module.scss';

type ProductCardProps = Product & { isSelected: boolean; onToggle(): void };

const ProductCard = (props: ProductCardProps) => {
  const { brand, name, variants, isSelected, onToggle } = props;
  const imageUrl = variants?.[0].imageUrl;

  return (
    <div className={styles.productCard}>
      <button
        className={styles.imageWrapper}
        onClick={onToggle}
        aria-pressed={isSelected}
        aria-label={`Select ${name}`}
      >
        <img className={isSelected ? styles.isSelected : ''} src={imageUrl} alt={name} />
      </button>
      <p className={styles.brand}>{brand}</p>
      <p>{name}</p>
    </div>
  );
};

export { ProductCard };
